import {library} from '@fortawesome/fontawesome-svg-core';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons';

library.add(
  faChevronRight
);
